export default __webpack_public_path__ + "static/media/SELLING 2.71cc8d9d.png";